import { useContext } from "react";
import { SharedLocationContext } from "./SharedLocationContext";

const useSharedLocation = () => useContext(SharedLocationContext);

export default useSharedLocation;
